
import { SigninContent } from "../../components/auth"

export default function Auth () {

  return (
    <>
      <SigninContent/>
    </>
  )

}